import { IFsMap } from '@lib/geo/core';
import { IMarker, MarkerEventType } from '@lib/geo/map';

export interface EsriEvent {
  native?: MouseEvent | PointerEvent | TouchEvent;
  mapPoint?: {
    latitude: number;
    longitude: number;
  };
}

export interface EventConfig<TMap extends IFsMap> {
  esriEventName: string;
  createEventData: (marker: IMarker<TMap>) => Record<string, unknown>;
}

export type EventConfigMap<TMap extends IFsMap> = {
  [K in MarkerEventType]: EventConfig<TMap>;
};
